import type { HTMLAttributes } from 'react';

import React from 'react';

import { classNames } from '../../../utils/class-names';

import styles from './table-cell.module.css';

export function TableCell<TableCellProps extends HTMLAttributes<HTMLTableCellElement>>({
  className,
  ...props
}: TableCellProps) {
  return <td className={classNames(className, styles.tableCell)} {...props} />;
}
